import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import * as emailjs from 'emailjs-com';


class Contact extends Component {

  constructor(props) {
    super(props);
this.state= {
    contactName:'',
    contactEmail:'',
    contactSubject:'',
    contactMessage:''
}
}

handleChangeContactName=(event)=>{
    this.setState({
        contactName:event.target.value,
    });
    
}
handleChangeContactEmail=(event)=>{
    this.setState({
        contactEmail:event.target.value,
    });
}
handleChangeContactSubject=(event)=>{
    this.setState({
        contactSubject:event.target.value,
    });
}
handleChangeContactMessage=(event)=>{
    this.setState({
        contactMessage:event.target.value,
    });
}
sendMail=()=>{
    

    var template_params = {
        "contactName": this.state.contactName,
        "contactEmail": this.state.contactEmail,
        "contactSubject": this.state.contactSubject,
        "contactMessage":this.state.contactMessage,
     }
     
     var service_id = "default_service";
     var template_id = "template_9rcrkqb";
     emailjs.send(service_id,template_id,template_params,'user_nPbwZjdz5HDQQSg6YmzG9')
     .then(function(response) {
       alert('Thank you!  Will be in touch!');
    }, function(err) {
       console.log('Oops...', err);
    });
};
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const state = this.props.data.address.state;
    const message = this.props.data.contactmessage;
    
    

    return (
      <section id="contact">
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <h1>
                <span>Get In Touch.</span>
              </h1>
            </div>

            <div className="ten columns">
              <p className="lead">{message}</p>
            </div>
          </div>
        </Fade>

        <div className="row">
          <Slide left duration={1000}>
            <div className="eight columns">
              
                          
                <fieldset>
                  <div>
                    <label htmlFor="contactName">
                      Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      
                      name="contactName"
                      onChange={this.handleChangeContactName}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactEmail">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      
                      name="contactEmail"
                      onChange={this.handleChangeContactEmail}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactSubject">Subject</label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      
                      name="contactSubject"
                      onChange={this.handleChangeContactSubject}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactMessage">
                      Message <span className="required">*</span>
                    </label>
                    <textarea
                      cols="50"
                      rows="15"
                      
                      name="contactMessage"
                      onChange={this.handleChangeContactMessage}
                    ></textarea>
                  </div>

                  <div>
                  
                  <button type="submit" className="submit" onClick={this.sendMail}>Submit</button>                    
                    <span id="image-loader">
                      <img alt="" src="images/loader.gif" />
                    </span>
                  </div>
                </fieldset>
                
              

              <div id="message-warning"> Oops... somethings missing.</div>
              <div id="message-success">
                <i className="fa fa-check"></i>Your message was sent, thank you!
                <br />
              </div>
            </div>
          </Slide>

          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact">
                <h4>Contact</h4>
                <p className="address">
                  {name}
                  <br />
                  {state}
                  <br />                  
                </p>
              </div>

              <div className="widget widget_tweets">
                <h4 className="widget-title">Latest Tweets</h4>
                <ul id="twitter">
                  <li>
                    <span>
                    Who has the happiest face here? Lol This is the place my children’s book idea got its final shape! Where do you get the best ideas? 
                      <a href="https://twitter.com/Carmelgoldendo3"><p>Barbara</p></a>
                    </span>
                    <b>
                      <a href="https://twitter.com/Carmelgoldendo3/status/1452241354973753355?s=20">October 24, 2021</a>
                    </b>
                  </li>
                  <li>
                    <span>
                    Therapy dogs are more important now than ever before.
                      <a href="https://twitter.com/Carmelgoldendo3"><p>Barbara</p></a>
                    </span>
                    <b>
                      <a href="https://twitter.com/Carmelgoldendo3/status/1453768702135050247?s=20">October 28, 2021</a>
                    </b>
                  </li>
                </ul>
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
